import { useLocation, matchPath } from 'react-router-dom';
import { NgApp } from '@hotjar/webapp/features/Angular/NgApp';
import { Page40x } from '@hotjar/webapp/features/40xPage/40xPage';
import Error404Image from '@hotjar/shared-assets/images/error-404.png';
import { AUTH } from '@hotjar/webapp/constants/routes';
import { navigateTo } from '@hotjar/webapp/utils/routing';

// This list doesn't _have_ to be kept in sync with webapp-ng since routes that get migrated
// will match first with react-router and we won't get here anyway.
const knownAngularRoutesPrefixes = [
  '/settings/invoices',
  '/settings/billing',
  '/feedback',
  '/surveys',
  '/polls',
  '/site/:siteId/settings',
];

export function FallbackRouteHandler(): JSX.Element {
  const location = useLocation();

  const isMatch = knownAngularRoutesPrefixes.some((prefix) =>
    Boolean(matchPath(prefix, location.pathname)),
  );

  // We know the current pathname is handled by the Angular app, so we can render the angular app
  // here otherwise we show a 404 page.
  if (isMatch) {
    return <NgApp />;
  }

  return (
    <Page40x
      title="40x.404.title"
      description="40x.404.description"
      imgSrc={Error404Image}
      redirectToLoginPage={() => {
        navigateTo(AUTH.LOGIN.path);
      }}
    />
  );
}
